import { render, staticRenderFns } from "./UntypedEdit.vue?vue&type=template&id=54ff1966"
import script from "./UntypedEdit.vue?vue&type=script&lang=js"
export * from "./UntypedEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports